module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_zh-hans_PC-11ea289ee27e61a66a02521db7a20cf6.jpg";